module.exports = __webpack_public_path__ + "media/images/lp/history2-pc-8df6e59f60392c9bacb6c4b8b55d5682.jpg";